import { FadeUp } from "./Reveal";

const STATS = [
    { value: "< 1 min", label: "import van het jaarverslag" },
    { value: "∞", label: "scenario's per dossier" },
    { value: "P10–P90", label: "kansberekening standaard inbegrepen" },
    { value: "100%", label: "Nederlands, voor bestuurders én financieel professionals" },
];

const Stats = () => (
    <section data-testid="stats-section" className="bg-white border-y border-black/10">
        <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4">
            {STATS.map((s, i) => (
                <FadeUp
                    key={s.label}
                    delay={i * 0.08}
                    className={`px-6 md:px-10 py-14 md:py-20 border-black/10 ${
                        i % 2 === 0 ? "border-r" : "lg:border-r"
                    } ${i < 2 ? "border-b lg:border-b-0" : ""} ${i === 3 ? "lg:border-r-0" : ""} ${
                        i === 2 ? "border-r lg:border-r" : ""
                    }`}
                >
                    <p data-testid={`stat-value-${i}`} className={`font-heading ${i % 2 === 1 ? "text-[#FF6B00]" : "text-[#0047FF]"} font-black tracking-tight text-4xl md:text-5xl`}>
                        {s.value}
                    </p>
                    <p className="mt-3 text-sm md:text-base text-[#0A0A0A]/60 font-medium leading-snug">{s.label}</p>
                </FadeUp>
            ))}
        </div>
    </section>
);

export default Stats;
